<template>
	<div class="display">

		<v-list class="section-container" two-line>
			<v-list-tile>
          		<v-list-tile-content>
          			<v-list-tile-sub-title>Item Code</v-list-tile-sub-title>
          			<v-list-tile-title>{{displayData.productCode ? displayData.productCode : '-'}}</v-list-tile-title>
            	</v-list-tile-content>
        	</v-list-tile>

        	<v-divider></v-divider>

			<v-list-tile>
          		<v-list-tile-content>
          			<v-list-tile-sub-title>Item Type</v-list-tile-sub-title>
          			<v-list-tile-title>{{displayData.groupTypeId == 101 ? 'Goods' : 'Service'}}</v-list-tile-title>
            	</v-list-tile-content>
        	</v-list-tile>

        	<v-divider></v-divider>

        	<v-list-tile>
	          	<v-list-tile-content>
	          		<v-list-tile-sub-title>Unit</v-list-tile-sub-title>
	          		<v-list-tile-title>{{displayData.productVariants[0].unitName}}</v-list-tile-title>
	            </v-list-tile-content>
	        </v-list-tile>

	        <template v-if="displayData.groupTypeId==101">
	        	<v-divider></v-divider>

		        <v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>{{displayData.inventory ? 'Sale Price' : 'Price'}}</v-list-tile-sub-title>
		          		<v-list-tile-title>
		          			<span v-if="displayData.sellingPrice">&#8377;</span> 
		              		{{displayData.sellingPrice ? $root.numberToLocale(displayData.sellingPrice) : '-'}}
		          		</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>	
	        </template>

	        <template v-if="displayData.inventory && displayData.groupTypeId==101">
	        	<v-divider></v-divider>
	       	 	<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Whole Sale Price</v-list-tile-sub-title>
		          		<v-list-tile-title>
		          			<span v-if="displayData.wholeSalePrice">&#8377;</span> 
		              		{{displayData.wholeSalePrice ? $root.numberToLocale(displayData.wholeSalePrice) : '-'}}
		          		</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
	       	</template>

	       	<template v-if="$root.TransactionSettings.mrpWiseStock && displayData.inventory">
	       		<v-divider></v-divider>
	       	 	<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>MRP</v-list-tile-sub-title>
		          		<v-list-tile-title>
		          			<span v-if="displayData.mrp">&#8377;</span> 
		              		{{displayData.mrp ? $root.numberToLocale(displayData.mrp) : '-'}}
		          		</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
	       	</template>

	       	<template v-if="displayData.groupTypeId==102">
	       		<v-divider></v-divider>
	       	 	<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Charges</v-list-tile-sub-title>
		          		<v-list-tile-title>&#8377; {{displayData.charges ? $root.numberToLocale(displayData.charges) : '-'}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
	       	</template>
		</v-list>

		<v-list class="section-container" two-line v-if="$root.CurrentBusiness && $root.CurrentBusiness.GSTRegistrationStatus==1">
	        <v-subheader light>Tax Details</v-subheader>
	        <v-divider></v-divider>

			<v-list-tile v-if="displayData.newTaxCategoryName">
	          	<v-list-tile-content>
	          		<v-list-tile-sub-title>GST 2.0 (from 22-Sep-2025)</v-list-tile-sub-title>
	          		<v-list-tile-title>{{displayData.newTaxCategoryName ? displayData.newTaxCategoryName : '-'}}</v-list-tile-title>
	            </v-list-tile-content>
	        </v-list-tile>

	        <v-list-tile>
	          	<v-list-tile-content>
	          		<v-list-tile-sub-title>GST 1.0 (before 22-Sep-2025)</v-list-tile-sub-title>
	          		<v-list-tile-title>{{displayData.taxCategoryName ? displayData.taxCategoryName : '-'}}</v-list-tile-title>
	            </v-list-tile-content>
	        </v-list-tile>
	        
	       	<template v-if="displayData.hsnCode">
	       		<v-divider></v-divider>
	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>HSN Code</v-list-tile-sub-title>
		          		<v-list-tile-title>{{displayData.hsnCode ? displayData.hsnCode : '-'}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
	       	</template>
	    </v-list>

		<template v-if="displayData.batches && displayData.batches">
			<v-subheader class="mt-2 white-background">{{ displayData.selectedBatchType == 2 ? 'Series#' : 'Batches#' }}</v-subheader>
			<v-divider></v-divider>
			<template v-for="(batch, batchIndex) in displayData.batches">
				<v-card flat :key="batchIndex" v-if="batch.opening">
					<v-card-text>
						<v-layout class="batch_layout" row wrap>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
								<div light-opacity-color>Batch No.</div>
								<div>{{ batch.batchNumber }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
								<div light-opacity-color>Size</div>
								<div>{{ batch.batchSize }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
								<div light-opacity-color>MRP</div>
								<div>{{ batch.batchMRP }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
								<div light-opacity-color>Mfg. Date</div>
								<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
								<div light-opacity-color>Exp. Date</div>
								<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.opening && !batch.field1 && !batch.field2 && !batch.field3">
								<div light-opacity-color>Opening</div>
								<div>{{ batch.opening ? batch.opening : 0  }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
								<div light-opacity-color>Purchase Rate</div>
								<div>{{ batch.purchaseRate }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
								<div light-opacity-color>Serial Number</div>
								<div>{{ batch.field1 }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
								<div light-opacity-color>IMEI Number</div>
								<div>{{ batch.field2 }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
								<div light-opacity-color>Part Number</div>
								<div>{{ batch.field3 }}</div>
							</v-flex>
							<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
								<div light-opacity-color>Model Number</div>
								<div>{{ batch.field4 }}</div>
							</v-flex>
							<!-- <v-flex xs4 sm4 md4 mb-2>
								<div light-opacity-color>Quantity</div>
								<div>{{ batch.qty }}</div>
							</v-flex> -->
						</v-layout>
					</v-card-text>
				</v-card>
				<v-divider v-if="displayData.batches.length - 1 != batchIndex"></v-divider>
			</template>
			
		</template>

	    <v-list nopadding class="section-container" two-line :class="{'mt-2':displayData.batches}">
	    	<v-subheader light>Other Details</v-subheader>
	    	<v-divider></v-divider>
	    	<v-list-tile>
	          	<v-list-tile-content>
	          		<v-list-tile-sub-title>Category</v-list-tile-sub-title>
	          		<v-list-tile-title>{{displayData.productCategoryName ? displayData.productCategoryName : '-'}}</v-list-tile-title>
	            </v-list-tile-content>
	        </v-list-tile>

	        <v-divider></v-divider>

	        <v-list-tile>
	          	<v-list-tile-content>
	          		<v-list-tile-sub-title>Description</v-list-tile-sub-title>
	          		<v-list-tile-title>{{displayData.description ? displayData.description : '-'}}</v-list-tile-title>
	            </v-list-tile-content>
	        </v-list-tile>

	       		
	       	<template v-if="displayData.groupTypeId == 101 && displayData.inventory">
	       		<v-divider></v-divider>

				<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Brand</v-list-tile-sub-title>
		          		<v-list-tile-title>{{displayData.brandName ? displayData.brandName : '-'}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>

	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Company</v-list-tile-sub-title>
		          		<v-list-tile-title>{{displayData.companyName ? displayData.companyName : '-'}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>		       		
	       	</template>
	    </v-list>

	</div>
</template>

<script>
	export default{
		props:['displayData']
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/product/display_tabs/details.vue